<template>
  <div :class="['pincode_wrapper','row','align-items-start',class_name]">
    <div class="col" v-for="(i, index) in input" :key="`pincode-${index}`">
      <input
        @paste="onPaste"
        @input="onChange"
        @keyup="keyUp"
        :ref="`pincode-${name}-${index}`"
        v-ep-restrict.number
        :type="type?type:'text'"
        maxlength="1"
        v-model="input[index]"
        v-bind:name="name + '[]'"
        :data-id="`${index}`"
      />
    </div>
  </div>
</template>

<script>
import InputFilter from "./../filters/Input";

InputFilter();

export default {
  props: {
    input: Array,
    type: String,
    name: String,
    class_name: String,
    multiple: Boolean,
  },
  model: {
    prop: "input",
    event: "change"
  },
  mounted() {
    if (!this.multiple){
      this.$refs[`pincode-${this.name}-0`][0].focus();
    }

    if(this.multiple) {
      if(this.name === 'pincode') {
        this.$refs[`pincode-${this.name}-0`][0].focus();
        return
      }
      return
    }

  },
  methods: {
    keyUp(event) {
      let this_id = parseInt(event.target.attributes["data-id"].value);
      if (event.keyCode == 38 || event.keyCode == 37) {
        if (this_id > 0) {
          this.$refs[`pincode-${this.name}-${this_id - 1}`][0].focus();
        }
      } else if (event.keyCode == 40 || event.keyCode == 39) {
        if (this_id + 1 < this.input.length) {
          this.$refs[`pincode-${this.name}-${this_id + 1}`][0].focus();
        }
      }
    },
    onPaste(event) {
      let clipboardData =
        event.clipboardData ||
        event.originalEvent.clipboardData ||
        window.clipboardData;
      let pastedData = clipboardData.getData("text/plain");
      for (let i = 0; i < this.value.length; i++) {
        this.value[i] = pastedData[i] !== undefined ? pastedData[i] : "";
      }
      this.$emit("change", this.input);
    },
    onChange(e) {
      let this_id = parseInt(e.target.attributes["data-id"].value);
      if (["deleteContentBackward", "deleteContentForward"].includes(e.inputType)) {
        if (this_id > 0) {
          this.$refs[`pincode-${this.name}-${this_id - 1}`][0].focus();
        }
      } else if (!isNaN(e.data)) {
        if (this_id + 1 < this.input.length) {
          this.$refs[`pincode-${this.name}-${this_id + 1}`][0].focus();
        }
        if (this.input.join("").length === this.input.length) {
          this.$emit("onFishied");
        }
      }
      this.$emit("change", this.input);
    },
    reset() {
      this.$refs[`pincode-${this.name}-0`][0].focus();
    }
  }
};
</script>
<style>
</style>
